import { ISWCValidator } from '@App/helpers/validate'
import { containsNewLine } from '@App/helpers/work-entities-fields-validators'
import { OptionModel } from '@Entities/lib'

import { WriterModel } from '@Entities/work/writer-model'

// These validators check specific field of work entities and return isError: boolean

// Work detail fields //
export const workTitleInvalidCheck = (workTitle: string) =>
    !workTitle || !workTitle.length || workTitle.length > 200 || containsNewLine(workTitle)

export const durationInvalidCheck = (duration: string | null | undefined) =>
    !!(duration && !duration.match(/^[0-9]{2}[:]{1}[0-9]{2}$/))

export const copyrightOfficeNumberInvalidCheck = (copyrightOfficeNumber: string | null) =>
    !!(copyrightOfficeNumber && copyrightOfficeNumber.length > 12)

export const rightsholderProprietaryIdInvalidCheck = (rightsholderProprietaryId: string | null) =>
    !!(rightsholderProprietaryId && rightsholderProprietaryId.length > 14)

export const iswcInvalidCheck = (iswc: string | null) => !!(iswc && !ISWCValidator(iswc))

export const languageInvalidCheck = (languageCode: number | null, langsLib: OptionModel[], required: boolean) => {
    const langIds: number[] = langsLib ? langsLib.map((lang: OptionModel) => +lang.id) : []
    if (required) {
        return !languageCode || langIds.indexOf(languageCode) === -1
    }
    return !!(languageCode && langIds.indexOf(languageCode) === -1)
}

// Aka title fields //
export const akaTitleInvalidCheck = (akaTitle: string | null) =>
    !akaTitle || akaTitle.length > 500 || containsNewLine(akaTitle)

export const akaTitleTypeInvalidCheck = (akaTitleType: number | null, akaLib: OptionModel[]) => {
    const typeIds: number[] = akaLib ? akaLib.map((akaType: OptionModel) => +akaType.id) : []
    return !akaTitleType || typeIds.indexOf(akaTitleType) === -1
}

// Writer fields //
export const writerFirstNameInvalidCheck = (firstName: string | null) =>
    !!(firstName && (firstName.length > 60 || containsNewLine(firstName)))

export const writerLastNameInvalidCheck = (lastName: string) =>
    !lastName || !lastName.length || lastName.length > 200 || containsNewLine(lastName)

export const writerRoleInvalidCheck = (roleCode: number | null, rolesLib: OptionModel[]) => {
    const roleIds: number[] = rolesLib ? rolesLib.map((writerRole: OptionModel) => +writerRole.id) : []
    return !roleCode || roleIds.indexOf(roleCode) === -1
}

export const isComposerPresent = (writers: WriterModel[]) =>
    writers.some((writer: WriterModel) => writer.roleCode === 10 || writer.roleCode === 11)

// Publisher fields //
export const publisherNameInvalidCheck = (publisherName: string) =>
    !publisherName || publisherName.length > 200 || containsNewLine(publisherName)

export const publisherShareInvalidCheck = (publisherShare: number | null) =>
    Number(publisherShare) <= 0 || Number(publisherShare) > 100.06

// Recording fields //
export const recordingTitleInvalidCheck = (title: string | null | undefined) =>
    !title || title.length > 200 || containsNewLine(title)

export const artistNameInvalidCheck = (artistName: string | null | undefined) =>
    !artistName || !artistName.length || artistName.length > 60 || containsNewLine(artistName)

export const isrcInvalidCheck = (isrc: string | null | undefined) => !!(isrc && isrc.length !== 12)

export const labelInvalidCheck = (label: string | null | undefined) =>
    !!(label && (label.length > 60 || containsNewLine(label)))
